<div class="password-input2">


    <div class="input-group">


        <input
            id="password-input"
            [type]="showPassword() ? 'text' : 'password'"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="passwordValue()"
            (ngModelChange)="onPasswordChange($event )"
            (blur)="onPasswordBlur()"
            [disabled]="isDisabled()"
            [required]="required()"
            [attr.aria-label]="ariaLabel()"
            [attr.aria-invalid]="isTouched() && !validation().isValid"
            [attr.aria-describedby]="showPolicy() ? 'password-policy' : null"
            [class.password-input__field--invalid]="isTouched() && !validation().isValid"
            [class.password-input__field--valid]="isTouched() && validation().isValid"
            placeholder="{{ placeholder() }}"
            class="form-control" />
        <button type="button" class="btn btn-outline-secondary"
            (click)="showPassword.set(!showPassword())"
            [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            [attr.aria-pressed]="showPassword()">
            <i [class]="showPassword() ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'" aria-hidden="true"></i>
        </button>

    </div>
    @if (showPolicy() && !validation().isValid) {
    <div id="password-policy" class="password-input__policy">
        <div class="password-input__policy-title">Requerimientos:</div>

        @if (policy().minLength) {
        <div
            [class.password-input__policy-rule--met]="validation().minLengthMet"
            class="password-input__policy-rule">
            <span class="password-input__policy-icon">
                @if (validation().minLengthMet) {
                ✓
                } @else {
                ✗
                }
            </span>
            <span>Mínimo {{ policy().minLength }} caracteres</span>
        </div>
        }

        @if (policy().requireDigits) {
        <div
            [class.password-input__policy-rule--met]="validation().digitsMet"
            class="password-input__policy-rule">
            <span class="password-input__policy-icon">
                @if (validation().digitsMet) {
                ✓
                } @else {
                ✗
                }
            </span>
            <span>Al menos un dígito (0-9)</span>
        </div>
        }

        @if (policy().requireUppercase) {
        <div
            [class.password-input__policy-rule--met]="validation().uppercaseMet"
            class="password-input__policy-rule">
            <span class="password-input__policy-icon">
                @if (validation().uppercaseMet) {
                ✓
                } @else {
                ✗
                }
            </span>
            <span>Al menos una letra mayúscula (A-Z)</span>
        </div>
        }

        @if (policy().requireNonAlphanumeric) {
        <div
            [class.password-input__policy-rule--met]="validation().nonAlphanumericMet"
            class="password-input__policy-rule">
            <span class="password-input__policy-icon">
                @if (validation().nonAlphanumericMet) {
                ✓
                } @else {
                ✗
                }
            </span>
            <span>Al menos un carácter especial (!@#$%^&*)</span>
        </div>
        }
    </div>
    }
</div>